// components/Stats/RatingCard.jsx
import React, { useEffect, useState } from "react";
import StatCard from "./statCard"
import { FaStar } from "react-icons/fa";
import { MessageSquare } from "lucide-react";
import axios from "axios";
import { courseContent } from "../../data/courseContent";

export default function RatingCard({ rating, reviews, onActionClick }) {

  const safeReviews = Number(reviews ?? 0) || 0;
  const safeRating = Number(rating ?? 0) || 0;
  const displayRating = safeReviews > 0 ? Math.ceil(safeRating) : 0;

  const handleClick = onActionClick
   ?? (() => {
      const el = document.getElementById("reviewsSection")
      if (el) el.scrollIntoView({ behavior: "smooth" });
   })


  return (
    <StatCard
      icon={<FaStar className="w-6 h-6" />}
      label="Course Rating"
      value={displayRating}
      subtitle={`${safeReviews} student reviews`}
      actionText="View Reviews"
      actionIcon={<MessageSquare className="w-4 h-4" />}
      actionVariant="outline"
      actionOnClick={handleClick}
    />
  );
}
